import Image from 'next/image';

import {PAYMENT_METHOD_IMAGE_ATTRS, PAYMENT_METHOD_IMAGE_FOLDER} from './constants';

/**
 * Props for the PaymentMethodImage component
 */
export interface PaymentMethodImageProps {
    /**
     * The type of payment method to display (e.g. 'visa', 'mastercard', 'paypal')
     */
    methodType: string;
    /**
     * Optional CSS class name to apply to the image
     */
    className?: string;
    /**
     * Whether to show the default card image when methodType is not recognized
     * @default true
     */
    showDefaultCardOnBlank?: boolean;
}

/**
 * PaymentMethodImage component displays the appropriate payment method logo
 * based on the provided method type (e.g. Visa, MasterCard, PayPal).
 *
 * @param props - Component props
 * @returns Payment method image or null if no default should be shown
 */
export function PaymentMethodImage({
    methodType,
    className,
    showDefaultCardOnBlank = true,
}: PaymentMethodImageProps) {
    let attrs = PAYMENT_METHOD_IMAGE_ATTRS[methodType];

    if (!attrs) {
        if (!showDefaultCardOnBlank) {
            return null;
        }
        attrs = PAYMENT_METHOD_IMAGE_ATTRS['default-method'];
    }

    const src = `${PAYMENT_METHOD_IMAGE_FOLDER}${attrs.src}`;

    return (
        <Image
            src={src}
            alt=""
            width={attrs.width}
            height={attrs.height}
            className={className}
            priority={true}
            unoptimized={true}
        />
    );
}
